import React from 'react';
import { PanelScroll } from '../panelScroll/view/panelScroll';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'BigPanelScroll', 
  itemElt: (item, cmsOption) => <PanelScroll item={item} cmsOption={cmsOption} panelType = "big__type"/>
}